<template>
    <v-dialog v-model="dialog" max-width="700px">
        <v-card>
            <v-card-title class="justify-center">Update {{ hspl.plan_code }} </v-card-title>
            <v-divider></v-divider>
            <v-form ref="updHspl" v-model="updHsplValid" class="px-4">
                <v-row no-gutters class="px-1">
                    <v-col class="pr-4" cols="4">
                        <v-text-field v-model="hspl.plan_to_code" label="Tour operator ID"></v-text-field>
                    </v-col>
                    <v-col cols="8">
                        <v-text-field v-model="hspl.plan_to_naam" label="Tour operator Name"></v-text-field>
                    </v-col>
                </v-row>
                 <v-row no-gutters>
                    <v-col cols="12">
                        <v-text-field v-model="hspl.plan_ical_url" label="Import iCal URL"></v-text-field>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="3" class="pr-4">
                        <v-select v-model="hspl.plan_verhvergun_stat" :items="plan_verhvergun_statKeuzes" item-value="code" item-text="desc" label="Rent License"></v-select>
                    </v-col>
                    <v-col cols="9">
                        <v-text-field v-model="hspl.plan_verhvergun_ref" label="Rent License ID"></v-text-field>
                    </v-col>  
                </v-row>  
                <v-row no-gutters>
                    <!-- <v-col class="pr-4" cols="6">
                        <v-text-field v-model="hspl.plan_kadaster" label="Cadastre registry"></v-text-field>
                    </v-col> -->
                    <v-col cols="6">
                        <v-select v-model="hspl.plan_energie_label" :items="energy_labels" item-value="code" item-text="label" label="Energy label"  clearable></v-select>
                    </v-col>
                </v-row>
                <!-- <v-row no-gutters>
                    <v-col cols="3" class="pr-4">
                        <v-select v-model="hspl.plan_dac7" :disabled="!hspl.plan_dac7Allowed" :items="plan_dac7Keuzes" item-value="code" item-text="desc" label="DAC7"></v-select>
                    </v-col>
                </v-row>   -->
                <v-row no-gutters v-if="(hspl.plan_fewoflow_id > '') || (hspl.plan_fewoflow_end_dat > '')">
                    <v-col class="pr-4" cols="6">
                        <v-text-field v-model="hspl.plan_fewoflow_id" label="Fewoflow id" readonly></v-text-field>
                    </v-col>
                    <v-col cols="6">
                        <div class="pt-4" >
                            <date_picker4
                                label="Fewoflow end date"                                 
                                :datum="hspl.plan_fewoflow_end_dat"
                                field="hspl.plan_fewoflow_end_dat" 
                                icon="mdi-calendar-month-outline"
                                :isClearable="false"
                                @updateData="setEndSate"/> 
                        </div>
                    </v-col>
                </v-row>
            </v-form>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="primary mx-2" small @click="updHspl">Save</v-btn>
                <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import date_picker4 from '@/components/ui/date_picker4.vue';
    // import {bus} from "../../../main";

    export default {
        components: {
            date_picker4
        },
        data() { 
            return {
                dialog: false,
                hspl_encrid: null,
                updHsplValid: false,
                plan_verhvergun_statKeuzes: [],
                energy_labels: [],
                // plan_dac7Keuzes: [],
                hspl: {
                    plan_fewoflow_end_dat: '',
                }
            }
        },
        methods: {
            open(hspl_encrid) {
                this.$axios.post("ares/json/ares/huis/hspl/getHspl.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getHspl"
                    },
                    getHspl: {
                        hspl_encrid: hspl_encrid
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.hspl = res.data.getHspl;
                        this.energy_labels = res.data.energie_labels;
                        this.plan_verhvergun_statKeuzes = res.data.getHspl.plan_verhvergun_statKeuzes;
                        
                        // this.plan_dac7Keuzes = res.data.getHspl.plan_dac7Keuzes;
                        this.dialog = true;
                    }
                });
            },
            setEndSate(data){
                this.hspl.plan_fewoflow_end_dat = data.value;
            },
            updHspl() { 
                this.$axios.post("ares/json/ares/huis/hspl/updHspl.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "updHspl"
                    },
                    updHspl: {
                        hspl_encrid: this.hspl.hspl_encrid,
                        plan_to_code: this.hspl.plan_to_code,
                        plan_to_naam: this.hspl.plan_to_naam,
                        plan_ical_url: this.hspl.plan_ical_url,
                        plan_verhvergun_stat: this.hspl.plan_verhvergun_stat,
                        plan_verhvergun_ref: this.hspl.plan_verhvergun_ref,
                        // plan_kadaster: this.hspl.plan_kadaster,
                        plan_energie_label: this.hspl.plan_energie_label,
                        // plan_dac7: this.hspl.plan_dac7,
                        plan_fewoflow_end_dat: this.hspl.plan_fewoflow_end_dat,
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else { 
                        //this.$router.reload('/huis/onHuis/' + res.data.updHspl.huis_encrid);    
                        // bus.$emit("closeDialog", "reload");        
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.updHspl.text,
                            color: res.data.updHspl.color
                        });
                        this.$emit('updateData');
                        this.dialog = false;
                    }
                })
            },
        }
    }
</script>
